import React from 'react';

import {
  List,
} from '@mui/material';

import type { MealJson } from '@/types/domain/meal/entities/mealEntity';

import CustomListItem from '@/components/CustomListItem';
import { toStringDateTimeDisplay } from '@/utils/date';

const MealInfo: React.FC<{
  /** データ */
  data: MealJson,
}> = ({ data }) => {
  const {
    mealContent,
    measureDateTime,
  } = data.data;
  return (
    <List>
      <CustomListItem
        name="日時"
        content={toStringDateTimeDisplay(new Date(measureDateTime), true)}
      />
      <CustomListItem
        name="食事内容"
        content={mealContent}
      />
    </List>
  );
};

export default MealInfo;
